import React, {Fragment} from "react";
import SweetAlertBase from "../../../../ui/sweetalert/SweetAlertBase";
import SVG from "react-inlinesvg";
import shareReportSVG from "../../../../../assets/svg/ils/ils-share-video.svg";

class SA_ShareVideo extends SweetAlertBase {

    setHtml = (data) => (
        <Fragment>
            <SVG src={shareReportSVG}/>
            <h2>Video Shared</h2>
            <p>Scouting report has been sahred with {data.sharedWith} peoples successfully</p>
        </Fragment>
    );

    type() {
        return 'sm';
    }

    className() {
        return "share-done";
    }

    confirmButtonClasses() {
        return "btn btn-primary btn-md btn-block";
    }
};

export default SA_ShareVideo;